import React from 'react';
import propTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { noop } from 'lib/noop';

import styles from './ExpandedAssetModal.css';

/**
 * modal for dislaying an expanded/fullsize asset
 * @param {object} props - component props
 * @param {string} props.asset - url of asset
 * @param {string} props."data-test-id" - test id
 * @param {boolean} props.isOpen - whether modal is open or not
 * @param {string} props.size - modal size
 * @param {Function} props.toggle - function to toggle modal open state
 * @returns {React.Component} ExpandedAssetModal
 */
const ExpandedAssetModal = ({ asset, isOpen, size, toggle, 'data-test-id': testId }) => (
  <Modal
    className={styles.modal}
    data-test-id={testId}
    isOpen={isOpen}
    size={size}
    toggle={toggle}
  >
    <ModalHeader toggle={toggle}>Expanded Asset</ModalHeader>
    <ModalBody className="d-flex align-items-center justify-content-center">
      <a
        href={asset}
        rel="noopener noreferrer"
        target="_blank"
        title="Click to open in new tab"
      >
        <img className={styles.asset} alt={asset} src={asset} />
      </a>
    </ModalBody>
  </Modal>
);

ExpandedAssetModal.propTypes = {
  asset: propTypes.string,
  'data-test-id': propTypes.string,
  isOpen: propTypes.bool,
  size: propTypes.string,
  toggle: propTypes.func
};

ExpandedAssetModal.defaultProps = {
  asset: '',
  'data-test-id': 'amp-modal-nested',
  isOpen: false,
  size: 'lg',
  toggle: noop
};

export default ExpandedAssetModal;
